import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login';
import Success from '@/views/success';
import Blank from '@/views/404'
// import AI from '../components/Chatting/AI.vue';
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
  {
    path: '/success',
    name: 'success',
    component: Success,
  },
    {
      path: '/404',
      name: '404',
      component: Blank,
    },
  ]
});
router.beforeEach((to, from, next) => {
  console.log(to)
  if(to.name == "login"){

  }
  next();
  // axios
  //   .get(process.env.BASE_API + "/projectInfo/info?id=" + to.query.state)
  //   .then(response => {
  //     let info = response.data.data
  //     console.log(info)
  //     if (info && info.isCharge != 3) {
  //       next()
  //       // next({path:'/chatting?state='+ to.query.state})
  //     } else {
  //       // next({path: '/chatting'})
  //     }
  //   })
  //   .catch(function (error) {
  //     // 请求失败处理
  //     console.log(error);
  //   });
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js